import { render, staticRenderFns } from "./CompareConfigs.vue?vue&type=template&id=74141717"
import script from "./CompareConfigs.vue?vue&type=script&lang=js"
export * from "./CompareConfigs.vue?vue&type=script&lang=js"
import style0 from "./CompareConfigs.vue?vue&type=style&index=0&id=74141717&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports